import React from "react";
import { ButtonStyled } from "./Button.styles";

import { Icons, IconComponentName } from "@/shared/icons";

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children?: React.ReactNode;
  loading?: boolean;
  variant?: "primary" | "secondary" | "outline" | "ghost" | "danger";
  size?: "sm" | "md" | "lg" | "squareSm";
  fullWidth?: boolean;
  icon?: IconComponentName;
  // Legacy props para compatibilidad
  disable?: boolean;
  typeButton?: string;
}

const ICON_SIZE_MAP = {
  sm: 16,
  squareSm: 16,
  md: 20,
  lg: 24,
};

export const Button: React.FC<ButtonProps> = ({
  children,
  disabled = false,
  onClick,
  type = "button",
  loading = false,
  variant = "primary",
  size = "md",
  fullWidth = false,
  className,
  icon,
  // Legacy props
  disable,
  typeButton,
  ...rest
}) => {
  // Compatibilidad con props legacy
  const isDisabled = disabled || disable;
  const isFullWidth = fullWidth || typeButton === "block";

  const hasChildren = React.Children.count(children) > 0;

  if (!hasChildren && icon && !rest["aria-label"] && !rest["aria-labelledby"]) {
    if (import.meta.env.VITE_NODE_ENV !== "production") {
      console.warn(
        "Button with icon-only must have an aria-label or aria-labelledby prop for accessibility.",
      );
    }
  }

  const iconSize = ICON_SIZE_MAP[size || "md"];

  return (
    <ButtonStyled
      type={type}
      disabled={isDisabled || loading}
      onClick={onClick}
      $variant={variant}
      $size={size}
      $fullWidth={isFullWidth}
      $loading={loading}
      className={className}
      {...rest}
    >
      {loading ? (
        "Cargando..."
      ) : (
        <>
          {icon && <Icons name={icon} width={iconSize} height={iconSize} />}
          {children}
        </>
      )}
    </ButtonStyled>
  );
};

export default Button;
